module.exports = __webpack_public_path__ + "81d6c272954d7d2f63a1bbadf9bdd5c4.png";